import React from 'react';
import styled from 'styled-components';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { useSubmitter } from '../../../platform/Hook';
import { Button, Colors } from '../../../ui';
import { Roundings, Shadows } from '../../../ui/Standards';
import { useResolve } from '../../Container';
import { PassportModel } from '../../PassportModel';
import { ButtonStrip, LinkButton, Title } from '../../dashboard/elements/LayoutElements';
import { PopupManager } from '../../popups/PopupManager';
import { BoardInfo } from '../BoardInfo';
import { EditorSession } from '../EditorSession';
import { InlineWidget } from '../workspace/widgets/WidgetInterface';
import { joinPopup } from './JoinPopup';

const Frame = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    padding: .75rem 1.25rem;
    border-radius: ${Roundings.lg};
    box-shadow: ${Shadows.lg};
    background: white;
    border: solid .1875rem ${Colors.primary};
    user-select: none;
`;

const JoinMessage = ({ widget }: { widget: InlineWidget }) => {
    const board = useResolve(EditorSession).get(BoardInfo);
    const passport = useObserverReturningStore(useResolve(PassportModel));
    const popups = useResolve(PopupManager);
    const canKnock = passport.verify('bo:knock');
    const [onJoin] = useSubmitter(async () => await popups.invoke(joinPopup(board.id)), []);

    return <Frame>
        <Title color={Colors.text}>You are viewing this board in readonly mode.</Title>
        <ButtonStrip align="center">
            {canKnock && <Button variant="primary" onAction={onJoin}>Join Board</Button>}
            {!canKnock && <LinkButton variant="primary" href={`/${board.id}/join`}>Join Board</LinkButton>}
            <Button variant="common" onAction={() => widget.onClose()}>I&apos;m Just Looking</Button>
        </ButtonStrip>
    </Frame>;
};

const TemplateMessage = ({ widget }: { widget: InlineWidget }) => {
    const board = useResolve(EditorSession).get(BoardInfo);
    return <Frame>
        <Title size="sm" color={Colors.text}>You are viewing a Ludi board template.</Title>
        <ButtonStrip align="center">
            <LinkButton variant="primary" href={`/new/${board.id}`}>Use Template</LinkButton>
            <Button variant="text" onAction={() => widget.onClose()}>I&apos;m Just Looking</Button>
        </ButtonStrip>
    </Frame>;
};

export const ReadonlyMessage = ({ widget }: { widget: InlineWidget }) => {
    const board = useResolve(EditorSession).get(BoardInfo);
    if (board.type > 2) return null;
    return board.type === 1 ? <JoinMessage widget={widget} /> : <TemplateMessage widget={widget} />;
};

